import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  data: [],
  error: null,
  loading: false,
  reminderDetails: {
    data: {},
    loading: false,
    error: null,
  },
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_CLIENT_REMINDERS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.GET_CLIENT_REMINDERS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case actionTypes.GET_CLIENT_REMINDERS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.CREATE_CLIENT_REMINDER_LOADING:
    case actionTypes.GET_CLIENT_REMINDER_LOADING:
    case actionTypes.UPDATE_CLIENT_REMINDER_LOADING:
    case actionTypes.DELETE_CLIENT_REMINDER_LOADING:
      return {
        ...state,
        reminderDetails: {
          ...state.reminderDetails,
          loading: true,
          error: null,
        },
      };
    case actionTypes.CREATE_CLIENT_REMINDER_SUCCESS:
      return {
        ...state,
        data: [...state.data, payload],
        reminderDetails: {
          ...state.reminderDetails,
          data: {},
          loading: false,
          error: null,
        },
      };
    case actionTypes.GET_CLIENT_REMINDER_SUCCESS:
      return {
        ...state,
        reminderDetails: {
          ...state.reminderDetails,
          data: payload,
          loading: false,
        },
      };
    case actionTypes.UPDATE_CLIENT_REMINDER_SUCCESS:
      return {
        ...state,
        data: state.data.map((reminder) => {
          if (reminder.id === payload.id) return payload;
          return reminder;
        }),
        reminderDetails: {
          ...state.reminderDetails,
          data: {},
          loading: false,
          error: null,
        },
      };
    case actionTypes.DELETE_CLIENT_REMINDER_SUCCESS:
      return {
        ...state,
        data: state.data.filter((reminder) => reminder.id === payload.id),
        reminderDetails: {
          ...state.reminderDetails,
          data: {},
          loading: false,
          error: null,
        },
      };
    case actionTypes.CREATE_CLIENT_REMINDER_ERROR:
    case actionTypes.GET_CLIENT_REMINDER_ERROR:
    case actionTypes.UPDATE_CLIENT_REMINDER_ERROR:
    case actionTypes.DELETE_CLIENT_REMINDER_ERROR:
      return {
        ...state,
        reminderDetails: {
          ...state.reminderDetails,
          loading: false,
          error: payload,
        },
      };
    default:
      return { ...state };
  }
};
